import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import { historyChangeSide, type HistoryChangeRow } from './historyChangeRows';
import { HistoryValue } from './historyValue';
import { historyPathLabel } from './historyView';
export const HistoryChangeValue = t0 => {
  const $ = _c(3);
  const {
    row,
    side
  } = t0;
  let t1;
  if ($[0] !== row || $[1] !== side) {
    const fields = historyChangeSide(row, side);
    t1 = fields.length ? <Stack sx={{
      gap: "8px",
      padding: "8px 0px"
    }}>{fields.map(field => <Stack key={field.path} sx={{
        gap: "4px"
      }}>{field.path !== row.path && <Typography variant="body2">{historyPathLabel(field.path.slice(row.path.length))}</Typography>}<HistoryValue field={field} /></Stack>)}</Stack> : <HistoryValue />;
    $[0] = row;
    $[1] = side;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};